import { Component, ElementRef, OnInit, ViewChild } from "@angular/core";
import { NgxSpinnerService } from "ngx-spinner";
import { GLOBAL } from "src/app/services/global";
import { wsGenerarPDFService } from "src/app/services/wsGenerarPDF.service";
import { saveAs } from "file-saver";
declare var $: any;
@Component({
  selector: "app-formulario1303",
  templateUrl: "./formulario1303.component.html",
  styleUrls: ["./formulario1303.component.css"],
  providers: [wsGenerarPDFService],
})
export class Formulario1303Component implements OnInit {
  @ViewChild("dataHtml") dataHtml: ElementRef;

  public nombreMuni = GLOBAL.nombreMuni;
  public region = GLOBAL.region;
  public color = "#ffcc9a";
  public data = "variable data del ts";
  pages = [1, 2, 3];
  public propiedad;
  public propietarios;
  public representantePropietario;
  public permiso_notariado;
  public arquitectos;
  public empresas;
  public clasificacionModificar;
  public normaAgrupamiento;
  public numeroPermisoAnteriores;
  public antecedentes;

  constructor(
    private spinner: NgxSpinnerService,
    private _wsGenerarPDFService: wsGenerarPDFService) {}

  ngOnInit() {}
  ngAfterContentChecked() {
    this.ngAfterContentInit();
  }

  ngAfterContentInit() {
    //PROPIEDAD
    if (JSON.parse(localStorage.getItem("informacionPropiedad"))) {
      if (JSON.parse(localStorage.getItem("informacionPropiedad")).length > 0) {
        this.propiedad = JSON.parse(
          localStorage.getItem("informacionPropiedad")
        );

        if (this.propiedad[0].ubicacion == "Urbano") {
          $("#urbano").attr("checked", true);
        }
        if (this.propiedad[0].ubicacion == "Rural") {
          $("#rural").attr("checked", true);
        }
      } else {
        localStorage.setItem("informacionPropiedad", JSON.stringify([]));
        this.propiedad = [
          {
            rol: "",
            id_direcc: "",
            folio: "",
            calle: "",
            calle_num: 0,
            ubicacion: "",
            direccion_completa: "",
            direc_complemento: "",
            direc_compl_num: "",
            loteo: "",
            manzana: "",
            plano: "",
            recordId: "",
          },
        ];
      }
    } else {
      localStorage.setItem("informacionPropiedad", JSON.stringify([]));
      this.propiedad = [
        {
          rol: "",
          id_direcc: "",
          folio: "",
          calle: "",
          calle_num: 0,
          ubicacion: "",
          direccion_completa: "",
          direc_complemento: "",
          direc_compl_num: "",
          loteo: "",
          manzana: "",
          plano: "",
          recordId: "",
        },
      ];
    }

    //PROPIETARIOS
    if (JSON.parse(localStorage.getItem("propietarios"))) {
      if (JSON.parse(localStorage.getItem("propietarios")).length > 0) {
        this.propietarios = JSON.parse(localStorage.getItem("propietarios"));
      } else {
        localStorage.setItem("propietarios", JSON.stringify([]));
        this.propietarios = [
          {
            rut: "",
            nombre: "",
            apellido_mat: "",
            apellido_pat: "",
            direccion: "",
            direccion_num: "",
            direccion_complemento: "",
            direccion_completa: "",
            comuna: "",
            fono: "",
            fax: "",
            mail: "",
            recordId: "",
          },
        ];
      }
    }

    //REPRESENTANTE PROPIETARIO
    if (JSON.parse(localStorage.getItem("representantes"))) {
      if (JSON.parse(localStorage.getItem("representantes")).length > 0) {
        this.representantePropietario = JSON.parse(
          localStorage.getItem("representantes")
        ); //no es obligatorio pero si tiene informacion debe estar permiso_notariado obligatoriamente
      } else {
        localStorage.setItem("representantes", JSON.stringify([]));
        this.representantePropietario = [
          {
            rut: "",
            nombre: "",
            apellido_mat: "",
            apellido_pat: "",
            direccion: "",
            direccion_num: "",
            direccion_complemento: "",
            direccion_completa: "",
            comuna: "",
            fono: "",
            fax: "",
            mail: "",
            recordId: "",
          },
        ];
      }
    } else {
      localStorage.setItem("propietarioRepresentante", JSON.stringify([]));
      this.representantePropietario = [
        {
          rut: "",
          nombre: "",
          apellido_mat: "",
          apellido_pat: "",
          direccion: "",
          direccion_num: "",
          direccion_complemento: "",
          direccion_completa: "",
          comuna: "",
          fono: "",
          fax: "",
          mail: "",
          recordId: "",
        },
      ];
    }

    //PERMISO NOTARIADO
    if (JSON.parse(localStorage.getItem("permiso_notariado"))) {
      if (JSON.parse(localStorage.getItem("permiso_notariado")).length > 0) {
        this.permiso_notariado = JSON.parse(
          localStorage.getItem("permiso_notariado")
        );
      } else {
        localStorage.setItem("permiso_notariado", JSON.stringify([]));
        this.permiso_notariado = [
          { acreditacion: "", fecha: null, escritura: null, notario: "" },
        ];
      }
    }

    //ARQUITECTOS
    if (JSON.parse(localStorage.getItem("arquitectos"))) {
      if (JSON.parse(localStorage.getItem("arquitectos")).length > 0) {
        this.arquitectos = JSON.parse(localStorage.getItem("arquitectos"));
      } else {
        localStorage.setItem("arquitectos", JSON.stringify([]));
        this.arquitectos = [
          {
            rut: "",
            nombre: "",
            mail: "",
            apellido_mat: "",
            apellido_pat: "",
            direccion: "",
            direccion_complemento: "",
            direccion_num: "",
            comuna: "",
            fono: "",
            fax: "",
            patente: "",
            recordId: "",
          },
        ];
      }
    }

    //EMPRESAS
    if (JSON.parse(localStorage.getItem("empresas"))) {
      if (JSON.parse(localStorage.getItem("empresas")).length > 0) {
        this.empresas = JSON.parse(localStorage.getItem("empresas"));
      } else {
        localStorage.setItem("empresas", JSON.stringify([]));
        this.empresas = [
          {
            rut: "",
            nombre: "",
            direccion: "",
            direccion_num: "",
            direccion_complemento: "",
            direccion_completa: "",
            comuna: "",
            fono: "",
            fax: "",
            mail: "",
            recordId: "",
          },
        ];
      }
    } else {
      localStorage.setItem("empresas", JSON.stringify([]));
      this.empresas = [
        {
          rut: "",
          nombre: "",
          direccion: "",
          direccion_num: "",
          direccion_complemento: "",
          direccion_completa: "",
          comuna: "",
          fono: "",
          fax: "",
          mail: "",
          recordId: "",
        },
      ];
    }

    //normas_agrupamiento
    if (JSON.parse(localStorage.getItem("normas_agrupamiento"))) {
      if (JSON.parse(localStorage.getItem("normas_agrupamiento")).length > 0) {
        this.normaAgrupamiento = JSON.parse(
          localStorage.getItem("normas_agrupamiento")
        );
        if (this.normaAgrupamiento[0].Norma_Seguridad == "SI") {
          $("#Norma_Seguridad_SI").prop("checked", true);
        }
        if (this.normaAgrupamiento[0].Norma_Seguridad == "NO") {
          $("#Norma_Seguridad_NO").prop("checked", true);
        }
        if (this.normaAgrupamiento[0].Norma_estabilidad == "SI") {
          $("#Norma_estabilidad_SI").prop("checked", true);
        }
        if (this.normaAgrupamiento[0].Norma_estabilidad == "NO") {
          $("#Norma_estabilidad_NO").prop("checked", true);
        }
        if (this.normaAgrupamiento[0].Permiso_Anteriores == "SI") {
          $("#Permiso_Anteriores_SI").prop("checked", true);
        }
        if (this.normaAgrupamiento[0].Permiso_Anteriores == "NO") {
          $("#Permiso_Anteriores_NO").prop("checked", true);
        }
        if (this.normaAgrupamiento[0].Recepcion_Anteriores == "SI") {
          $("#Recepcion_Anteriores_SI").prop("checked", true);
        }
        if (this.normaAgrupamiento[0].Recepcion_Anteriores == "NO") {
          $("#Recepcion_Anteriores_NO").prop("checked", true);
        }
        if (this.normaAgrupamiento[0].Tipo_Agrupamiento == "AISLADO") {
          $("#AISLADO").prop("checked", true);
        }
        if (this.normaAgrupamiento[0].Tipo_Agrupamiento == "CONTINUO") {
          $("#CONTINUO").prop("checked", true);
        }
        if (this.normaAgrupamiento[0].Tipo_Agrupamiento == "PAREADO") {
          $("#PAREADO").prop("checked", true);
        }
        if (this.normaAgrupamiento[0].Norma_Complementaria == "ADOSAMIENTO") {
          $("#ADOSAMIENTO").prop("checked", true);
        }
        if (this.normaAgrupamiento[0].Establecimiento == "Establecimiento_Educacion") {
          $("#Establecimiento_Educacion").prop("checked", true);
        }
        if (this.normaAgrupamiento[0].Establecimiento == "Establecimiento_Regidos") {
          $("#Establecimiento_Regidos").prop("checked", true);
        }
      } else {
        localStorage.setItem("normas_agrupamiento", JSON.stringify([]));
        this.normaAgrupamiento = [
          {
            Permiso_Anteriores: "",
            Recepcion_Anteriores: "",
            Numero_Permiso_Anteriores: "",
            Edificacion_Permiso1: "",
            Edificacion_Regularizada1: "",
            Edificacion_Permiso2: "",
            Edificacion_Regularizada2: "",
            Edificacion_Permiso3: "",
            Edificacion_Regularizada3: "",
            Edificacion_Permiso_Total: "",
            Edificacion_Regularizada_Total: "",
            Total_Regularizar: "",
            Total_Edificar_Predio: "",
            Total_Predio: "",
            Tipo_Agrupamiento: "",
            Norma_Complementaria: "",
            Altura_Minima: "",
            Medida_Minima: "",
            Terminacion_Interior: "",
            Ventilacion: "",
            Resistencia_Fuego_Edificio: "",
            Resistencia_Fuego_Adosamiento: "",
            Norma_Seguridad: "",
            Norma_estabilidad: "",
            Establecimiento:"",
          },
        ];
      }
    }

    //Numero de permisos
    if (JSON.parse(localStorage.getItem("Numero_Permiso_Anteriores"))) {
      if (
        JSON.parse(localStorage.getItem("Numero_Permiso_Anteriores")).length > 0
      ) {
        this.numeroPermisoAnteriores = JSON.parse(
          localStorage.getItem("Numero_Permiso_Anteriores")
        );
      } else {
        localStorage.setItem("Numero_Permiso_Anteriores", JSON.stringify([]));
      }
    }

    //  CLASIFICACIÓN(ES) clasificacionModificar
    if (JSON.parse(localStorage.getItem("clasificacionModificar"))) {
      if (
        JSON.parse(localStorage.getItem("clasificacionModificar")).length > 0
      ) {
        this.clasificacionModificar = JSON.parse(
          localStorage.getItem("clasificacionModificar")
        );
      } else {
        localStorage.setItem("clasificacionModificar", JSON.stringify([]));
        this.clasificacionModificar = [
          {
            clasificacion: "",
            metro: "",
          },
        ];
      }
    } else {
      localStorage.setItem("clasificacionModificar", JSON.stringify([]));
      this.clasificacionModificar = [
        {
          clasificacion: "",
          metro: "",
        },
      ];
    }

    //  ANTECEDENTES QUE SE ADJUNTAN
    if (JSON.parse(localStorage.getItem("antecedentes"))) {
      if (JSON.parse(localStorage.getItem("antecedentes")).length > 0) {
        this.antecedentes = JSON.parse(localStorage.getItem("antecedentes"));

        for (let ant = 0; ant < this.antecedentes.length; ant++) {
          const filaAnt = this.antecedentes[ant];
          if (filaAnt) {
            var aux = "#" + filaAnt.id;
            $(aux).attr("checked", true);
          }
        }
      } else {
        localStorage.setItem("antecedentes", JSON.stringify([]));
        this.antecedentes = [];
      }
    } else {
      localStorage.setItem("antecedentes", JSON.stringify([]));
      this.antecedentes = [];
    }
  }

  DescargarPdf() {
    this.spinner.show();
    console.log("entre", this.dataHtml);

    this._wsGenerarPDFService
      .getBase64(this.dataHtml.nativeElement.innerHTML, this.color)
      .subscribe(
        (response) => {
          console.log("response", response);

          let blob = this.convertBase64ToBlobData(response.data);
          let title = localStorage.getItem("formTitle") + ".pdf";
          saveAs(blob, title);
          this.spinner.hide();
        },
        (error) => {
          console.log("error", error);
        }
      );
  }

  convertBase64ToBlobData(
    base64Data: string,
    contentType: string = "image/png",
    sliceSize = 512
  ) {
    const byteCharacters = atob(base64Data);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);

      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);

      byteArrays.push(byteArray);
    }

    const blob = new Blob(byteArrays, { type: contentType });
    return blob;
  }

}
